<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('notificationTemplate.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('notificationTemplate.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{ $t('add_new') }}</ts-button>
          <div class="d-flex ts-space-x-3">
            <ts-input
              v-model="search"
              :placeholder="$t('notificationTemplate.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
					field: 'not_type.not_types'
				}"
      >
        <template v-slot="{ record }">
          <td>{{ record.not_subject }}</td>
          <td>{{ record.channel_list }}</td>
          <td>{{ $store.getters.limitStringShow(record.not_content) }}</td>
          <td>{{ record.not_type.not_types }}</td>
          <td>{{ record.language.language_name }}</td>
          <td class="text-center">
              <span class="badge badge-success" v-if="record.is_active"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <!-- <a-popconfirm
              class="ts-cursor-pointer"
              placement="left"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <template slot="title">
                <p>{{ $t('are_you_sure_to_delete') }}</p>
              </template>
              <i
                class="fas fa-circle-notch spin ml-2"
                v-if="record._deleting"
              ></i>
              <i class="fa fa-trash ml-2 text-red" v-else></i>
            </a-popconfirm>-->
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'notificationType',
  data() {
    return {
      languages: [],
      loading: false,
      visible: false
    }
  },
  created() {
    this.fetchLang()
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/notificationTemplate', [
      'resources',
      'pagination'
    ]),
    search: {
      get() {
        return this.$store.state.administrator.notificationTemplate.search
      },
      set(newValue) {
        this.$store.commit(
          'administrator/notificationTemplate/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'administrator/notificationTemplate/RESET_CURRENT_PAGE'
        )
      }
    },
    columns() {
      return [
        { name: this.$t('notificationTemplate.subject') },
        { name: this.$t('notificationTemplate.channel') },
        { name: this.$t('notificationTemplate.content') },
        { name: this.$t('notificationTemplate.notType') },
        { name: this.$t('language') },
        {
          name: this.$t('notificationTemplate.active'),
          style: 'text-align:center; width: 1px;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    ...mapActions('administrator/notificationTemplate', ['destroy', 'getLang']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/notificationTemplate/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'notification-template-create' })
    },
    fetchLang() {
      this.getLang()
        .then(response => {
          this.languages = response.data.map(el => ({
            value: el.lang_id,
            label: el.language_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
		},
		edit(record) {
      this.$store.commit('administrator/notificationTemplate/SET_EDIT_DATA', record)
      this.$router.push({ name: 'notification-template-edit', params: { id: record.not_setup_id } })
    }
		
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    langId: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/notificationTemplate/RESET_STATE')
    next()
  }
}
</script>